import React from 'react'
import { Typography, Chip, Tooltip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })

const CadeiaNo = ({ no, nivel = 0, tituloId }) => {
  const { t } = useTranslation()
  const destacado = Number(no.id) === Number(tituloId)
  return (
    <div style={{ marginLeft: nivel * 24, borderLeft: nivel ? '2px solid #e0e0e0' : 'none', paddingLeft: nivel ? 12 : 0, marginTop: 6 }}>
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: destacado ? '#FFF6DA' : 'transparent',
          border: destacado ? '1px solid #F2C94C' : '1px solid transparent',
          borderRadius: 4, padding: '2px 6px',
        }}
      >
        <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: destacado ? 700 : 400 }}>{no.codigo}</span>
        {no.empresaDestinataria?.nome && (
          <Typography variant="caption" style={{ color: '#455a64' }}>— {no.empresaDestinataria.nome}</Typography>
        )}
        <Chip
          size="small"
          label={no.tipo === 'comprador' ? t('titulosLbc.comprado') : t('titulosLbc.origem')}
          style={{ backgroundColor: no.tipo === 'comprador' ? '#31ADE3' : '#219754', color: '#fff', height: 18 }}
        />
        <Tooltip title={t('titulosLbc.disponivelTotalTooltip')} arrow>
          <Typography variant="caption" color="textSecondary" style={{ cursor: 'help' }}>
            {fmt(no.quantidadeDisponivel)} / {fmt(no.quantidadeTotal)} *
          </Typography>
        </Tooltip>
      </div>
      {(no.filhos || []).map((filho) => (
        <div key={filho.operacao.id}>
          <Typography variant="caption" style={{ display: 'block', marginLeft: 24, marginTop: 4, color: '#607d8b' }}>
            ↳ {filho.operacao.codigo} · {t(`operacoesLbc.${filho.operacao.tipo === 'emissao' ? 'emissao' : 'transferirTitulo'}`)} · {fmt(filho.operacao.quantidade)}
          </Typography>
          <CadeiaNo no={filho.titulo} nivel={nivel + 1} tituloId={tituloId} />
        </div>
      ))}
    </div>
  )
}

export default CadeiaNo
